import { useContext } from "react"
import { LayoutContext } from "../context/LayoutContext.tsx"

export const useLayouts = () => {
    const context = useContext(LayoutContext)
    if (context === undefined) {
        throw new Error('useLayout must be used within a LayoutProvider')
    }
    return context
}
